import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/EmailVerification";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const EmailVerificationTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="EmailVerification">
      <TabletNotice page="EmailVerification" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default EmailVerificationTablet;